import { createAxiosClient } from '@atlassian/temp-client-utils';
import type { ExternalProductsList } from './types';

const bffClient = createAxiosClient({ baseURL: '/api/1' }, '');

interface FetchCloudSiteProductsBelongingToOtherTxa {
  currentTransactionAccountId: string;
  cloudSiteIds: string[];
}

export const fetchCloudSiteProductsBelongingToOtherTxa = async (
  payload: FetchCloudSiteProductsBelongingToOtherTxa
): Promise<ExternalProductsList> => {
  const productIdResponse = await bffClient.post('/cloud-site/products-belonging-to-other-txa', payload);
  return productIdResponse.data;
};
